// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  NewReminderUserSettingsRecordDataActivitySummary,
  type ReminderUserSettingsRecordDataActivitySummary,
  type ReminderUserSettingsRecordDataActivitySummaryWireFormat,
} from '../ReminderUserSettingsRecordDataActivitySummary/ReminderUserSettingsRecordDataActivitySummary';
import {
  NewReminderUserSettingsRecordDataProjectSummary,
  type ReminderUserSettingsRecordDataProjectSummary,
  type ReminderUserSettingsRecordDataProjectSummaryWireFormat,
} from '../ReminderUserSettingsRecordDataProjectSummary/ReminderUserSettingsRecordDataProjectSummary';
import {
  NewReminderUserSettingsRecordDataQuoteSummary,
  type ReminderUserSettingsRecordDataQuoteSummary,
  type ReminderUserSettingsRecordDataQuoteSummaryWireFormat,
} from '../ReminderUserSettingsRecordDataQuoteSummary/ReminderUserSettingsRecordDataQuoteSummary';

export class ReminderUserSettingsRecordData {
  readonly project?: ReminderUserSettingsRecordDataProjectSummary | null;
  readonly quote?: ReminderUserSettingsRecordDataQuoteSummary | null;
  readonly activity?: ReminderUserSettingsRecordDataActivitySummary | null;

  constructor(data: { [key: string]: any } = {}) {
    this.project =
      // eslint-disable-next-line no-nested-ternary
      (data.project ?? null) === null
        ? null
        : NewReminderUserSettingsRecordDataProjectSummary(data.project);
    this.quote =
      // eslint-disable-next-line no-nested-ternary
      (data.quote ?? null) === null
        ? null
        : NewReminderUserSettingsRecordDataQuoteSummary(data.quote);
    this.activity =
      // eslint-disable-next-line no-nested-ternary
      (data.activity ?? null) === null
        ? null
        : NewReminderUserSettingsRecordDataActivitySummary(data.activity);
  }

  static zero(): ReminderUserSettingsRecordData {
    const zeroValues: ExcludeMethodsDeep<ReminderUserSettingsRecordData> = {};
    return new ReminderUserSettingsRecordData(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReminderUserSettingsRecordDataWireFormat = {
  project?: ReminderUserSettingsRecordDataProjectSummaryWireFormat | null;
  quote?: ReminderUserSettingsRecordDataQuoteSummaryWireFormat | null;
  activity?: ReminderUserSettingsRecordDataActivitySummaryWireFormat | null;
};

type NewReminderUserSettingsRecordDataProps = PartialDeep<
  ReminderUserSettingsRecordData,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordData: (
  props: NewReminderUserSettingsRecordDataProps,
) => ReminderUserSettingsRecordData = (props) => new ReminderUserSettingsRecordData(props);

type NewReminderUserSettingsRecordDataFromWireFormatProps = PartialDeep<
  ReminderUserSettingsRecordDataWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataFromWireFormat: (
  props: NewReminderUserSettingsRecordDataFromWireFormatProps,
) => ReminderUserSettingsRecordData = (props) => new ReminderUserSettingsRecordData(props);
